import React from 'react';
import img1 from '../assets/image 10.png';
import { IoIosArrowDropupCircle } from "react-icons/io";
import { IoIosArrowDropdownCircle } from "react-icons/io";
import { useState } from 'react';
import HdfcHistory from './HdfcHistory';

const HomeLoan = () => {
    const [isOpen,setIsOpen] = useState(false);

    function handleOpen(){
        setIsOpen(!isOpen);
    }

    return (
    <div className='flex flex-col items-center w-[94%] lg:w-[90%] my-3'>
        <div className='flex flex-row justify-between items-center w-full h-14'>
            <span className='flex items-center gap-5'>
                <p className='text-sm lg:text-lg text-primary'>Total Home Loan</p>
                <p className='text-md lg:text-2xl'>₹ 16,456 </p>
            </span>
            <span className='flex items-center gap-2'>
                <div className='h-5 w-5 flex items-center justify-center rounded-full bg-green-500 text-white'>1</div>
                <p className='text-md lg:text-lg'> Active</p>
                <div className='h-5 w-5 flex items-center justify-center rounded-full bg-gray-300 text-white ml-10'>0</div>
                <p className='text-gray-400'> Closed</p>
            </span>
        </div>
        <div className='visible flex justify-around items-center w-full h-14 rounded-lg bg-blue-500 bg-opacity-50 mt-2 text-center'> 
            <p className='text-primary text-md lg:text-lg w-[20%]'>Bank Name</p>
            <p className='text-primary text-md lg:text-lg w-[20%]'>Open Date</p>
            <p className='text-primary text-md lg:text-lg w-[20%]'>Age</p>
        </div>
        <div className='visible flex justify-around items-center w-full h-14 mt-2 text-center'> 
            <p className='flex w-[20%] justify-center'><img src={img1} width={40} alt=''></img></p>
            <p className='w-[20%] max-xl:text-sm'>28/01/2022</p>
            <div className='flex justify-end items-center w-[20%] '>
                <p className='mr-1 lg:mr-4 xl:mr-8 max-xl:text-sm'>2 Years</p>
                {isOpen ? <IoIosArrowDropupCircle onClick={()=> handleOpen()} className='text-3xl text-primary cursor-pointer max-lg:-mr-2'/> : <IoIosArrowDropdownCircle onClick={()=> handleOpen()} className='text-3xl text-primary cursor-pointer max-lg:-mr-2'/>}
            </div>
        </div>
        <div className={`grid w-full transition-smooth will-change-auto duration-300 overflow-hidden ${isOpen ? "visible grid-rows-[1fr] opacity-100" : "invisible grid-rows-[0fr] opacity-0"}`}>
            {<HdfcHistory/>}
        </div>
    </div>
    )
}

export default HomeLoan